var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDungeonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15h26v-3h6v3h7v-3h4v42H2V12h4v3h7v-3h6z",
    fill: "#e7e4dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h38v4H13z",
    fill: "#758190"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18h10v19H27zM47 48v14H17V48",
    fill: "#c1c8d1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.826 44H49v4H15v-4h14.174",
    fill: "#a8b0bc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 44l7-7h16l7 7",
    fill: "#758190"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 62v-5a3 3 0 116 0v5M35 62v-5a3 3 0 116 0v5",
    fill: "#c18e59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 54V33h6v21M58 54V33h-6v21",
    fill: "#c1c8d1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25v8H5v-8M59 25v8h-8v-8",
    fill: "#a8b0bc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2l-9 10h18z",
    fill: "#758190"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12v6h14v-6",
    fill: "#a8b0bc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21h14v4H25z",
    fill: "#758190"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h-4v-4a2 2 0 114 0z",
    fill: "#c18e59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54H2v8h15M47 54h15v8H47",
    fill: "#758190"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28h2v2H8zM54 28h2v2h-2z",
    fill: "#c1c8d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 43,
    fill: "#f7d881",
    r: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54 2h2v19h-2z",
    fill: "#cbc3b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55 8h-7l.293-.293A2.414 2.414 0 0049 6c0-.64.254-1.254.707-1.707L50 4h5z",
    fill: "#f7d881"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.999h2v19H8z",
    fill: "#cbc3b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h4v2h-4zM18 21h4v2h-4zM46 18h4v2h-4zM42 21h4v2h-4zM45 36h4v2h-4zM15 36h4v2h-4z",
    fill: "#d5cec2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14h4v2h-4z",
    fill: "#c1c8d1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6 57h2v2H6zM10 57h2v2h-2zM52 57h2v2h-2zM56 57h2v2h-2z",
    fill: "#a8b0bc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.999 54.183A2.985 2.985 0 0026 54c-.353 0-.686.072-1 .184v7.815h2v-7.816zM39 54.184c-.314-.112-.647-.184-1-.184s-.686.072-1 .184v7.815h2z",
    fill: "#976947"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19l-5 6h10zM55 19l-5 6h10z",
    fill: "#758190"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H2l.293-.293A2.414 2.414 0 003 6c0-.64.254-1.254.707-1.707L4 4h5z",
    fill: "#e47c6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8892a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.695 12a8.955 8.955 0 001.673-9.298L23 12zM4 25h4.117a4.956 4.956 0 001.023-3c0-.875-.245-1.685-.639-2.4zM50 25h4.117a4.956 4.956 0 001.023-3c0-.875-.245-1.685-.639-2.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDungeonIcon);
export default __webpack_public_path__ + "static/media/DungeonIcon.3da690c7.svg";
export { ForwardRef as ReactComponent };